// extracted by mini-css-extract-plugin
module.exports = {"primaryThemeColor":"#eb9658"};